import { sendMessage, sendGeneralizationMessage } from "@/services/api-v2/api-v2";
import { getCurrentUtcDatetime } from "@/utils/date";
import { v4 as uuidv4 } from "uuid";
import { notification } from "@/utils/notification";
import { ossBaseUrl } from "@/config/env";
import i18n from "@/i18n/config";

const GROUP_ICON = require("@/assets/group.png");

/**
 * 生成预发消息
 */
export const generatePreMessage = (user, conversation, type, text = null, attachment = null, length = null, markdown = null) => {
	const preMessageId = uuidv4();

	let attachmentUrl;
	if (type === 1) {
		attachmentUrl = ossBaseUrl + "/voices/" + attachment;
	} else if (type === 2) {
		attachmentUrl = ossBaseUrl + "/pictures/" + attachment;
	} else if (type === 8) {
		attachmentUrl = ossBaseUrl + "/video/" + attachment;
	} else {
		attachmentUrl = null;
	}

	const preMessage = {
		_id: preMessageId, // 客户端发送id
		_status: 0, // 客户端发送状态: 0=发送中; 1=发送成功; 2=发送失败;
		id: preMessageId,
		type: type,
		timestamp: getCurrentUtcDatetime(),
		text: text ? text : null,
		attachment: attachment ? attachment : null,
		attachment_url: attachmentUrl,
		length: length ? length : null,
		group_id: conversation.object_type === "group" ? conversation.object_id : null,
		group_name: conversation.object_type === "group" ? conversation.object_name : null,
		sender_id: user.id,
		sender_name: user.nickName,
		sender_avatar: user.avatar,
		receive_id: conversation.object_type === "personal" ? conversation.object_id : null,
		receive_name: conversation.object_type === "personal" ? conversation.object_name : null,
		receive_avatar: conversation.object_type === "personal" ? conversation.object_avatar : null,
		is_delete: false,
		is_sender: true,
		is_read: false,
		markdown: markdown,
	};
	return preMessage;
};

/**
 * 发送消息
 */
export const sendMessageRequest = (conversation, preMessage) => {
	if (conversation.object_type === "personal") {
		return sendMessage(preMessage.receive_id, null, preMessage.type, preMessage.text, preMessage.attachment, preMessage.length);
	} else {
		return sendMessage(null, preMessage.group_id, preMessage.type, preMessage.text, preMessage.attachment, preMessage.length);
	}
};

/**
 * 发送推送消息
 */
export const sendGeneralizationMessageRequest = (data) => {
	return sendGeneralizationMessage(data);
};

/**
 * 浏览器通知
 */
export const browserNotification = (message) => {
	const bodyMapping = (message) => {
		if (message.type === 1) {
			return i18n.t("messageJS.voice");
		}

		if (message.type === 2) {
			return i18n.t("messageJS.picture");
		}

		return message.text;
	};

	const tag = uuidv4();

	const title = message.group_id === null ? message.sender_name : message.group_name;

	const body = message.sender_name + ": " + bodyMapping(message);

	const icon = message.group_id === null ? `${ossBaseUrl}/avatars/${message.sender_avatar}` : GROUP_ICON;

	return notification(tag, title, body, icon);
};
